export default __webpack_public_path__ + "static/media/bedroom-1.41d01050.png";